$(document).ready(function() {
  console.log("Doc ready")
  
  if ($(window).width() > 1140) {
    setTimeout(function(){
      var currency = $('.bacurr-cur-blocker')
      $('.hide-desk').append(currency)
      $('.bacurr-dropdownChoices').addClass('bdd-white')
    }, 3500)
  }else if ($(window).width() < 640) {
    console.log('tes')
  }
  
  
  if ($(window).width() < 700) {
    $('.PageHeader__ImageWrapper').css({
      'transform': 'none !important'
    })  
  }

  if (window.screen.width >= 1024) {
    $('.collection-anim__container').mouseover(function () {
      $(this).css('flex', '2')
      let siblings = $(this).siblings()
      $(siblings).each(function (i, v) {
        $(this).css('flex', '1')
      })
    })
  }

  console.log(window.screen.width);
  
  $('#filter-collection').click(function(){
    $('body').css('overflow', 'hidden');
    $('#sidebar-filter').addClass('Drawer--show')
    $('.PageOverlay').addClass('is-visible')
  });

  $('#close-filter').click(function(){
    $('body').css('overflow', 'auto');
    $('#sidebar-filter').removeClass('Drawer--show')
    $('.PageOverlay').removeClass('is-visible')
  });

  $('.PageOverlay').click(function(){
    $('body').css('overflow', 'auto');
    $('#sidebar-filter').removeClass('Drawer--show')
    $('#sidebar-description').removeClass('Drawer--show')
    $('.PageOverlay').removeClass('is-visible')
  });
  
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      //     panel.classList.toggle('panel-active')
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }

  var icc = document.getElementsByClassName("samping");
  var o;

  for (o = 0; o < icc.length; o++) {
    icc[o].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      panel.classList.toggle('panel-active')
    });
  }
  
//   var filter = document.getElementsByClassName("samping");
//   var j;

//   for (j = 0; j < filter.length; j++) {
//     filter[j].addEventListener("click", function() {

//       var panel = this.nextElementSibling;
//       if (panel.style.maxHeight){
//         panel.style.maxHeight = null;
//       } else {
//         let active = document.querySelectorAll(".filterna-samping .samping.active");
//         for(let j = 0; j < active.length; j++){
//           active[j].classList.remove("active");
//           active[j].nextElementSibling.style.maxHeight = null;
//         }
//         this.classList.toggle("active");
//         panel.classList.toggle('panel-active')
//         panel.style.maxHeight = panel.scrollHeight + "px";
//       }
//     });
//   }


  $('#apply').on('click', function(){
    var filterna = [];
    $('.filter-checkbox').each(function(){
      if($(this).is(':checked')){
        filterna.push($(this).attr('tags'));
      }
    });
    var indexna = $(this).attr('data-url');
    //   console.log(filterna.join("+"))
    location.href = indexna + "/" + filterna.join("+");
  });

  $('#reset').on('click', function(){
    var indexna = $(this).attr('data-url');
    location.href = indexna;
  });

  $('#detail').click(function(){
    $('body').css('overflow', 'hidden');
    $('#sidebar-description').addClass('Drawer--show')
    $('.PageOverlay').addClass('is-visible')
  });

  $('#close-detail').click(function(){
    $('body').css('overflow', 'auto');
    $('#sidebar-description').removeClass('Drawer--show')
    $('.PageOverlay').removeClass('is-visible')
  });
  
  
//   var product_id = $('#variant-id').val()
//   $('.btn--pre-order').click(function(){
//     var test = jQuery.post('/cart/add.js', $('form[action="/cart/add"]').serialize());
//     console.log(test)
//   })

  if($("#AjaxinateLoop").length){
    let current_url = location.href

    if(current_url.includes('collections/all')){
      var clickPagination = setInterval(() => {
        if($("#AjaxinatePagination a").length){
          $("#AjaxinatePagination a")[0].click()
          $(".all-product-here").append($(".soldout-card"))
        }
  
        if($("#AjaxinatePagination").html() == ""){
          clearInterval(clickPagination);
        }
      }, 500);
    }
  }

  if($(".Product__SlideItem--video").length){
    const video = document.getElementById('product-video');
    video.addEventListener('click', function() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  }
})